import { PageGreetingLocale as StoreLocale } from '../enums/v2/PageGreetingLocale';
export class PageStoreTitleModel {
    constructor(payload) {
        this.uuid = '';
        this.storeTitle = { locale: StoreLocale.Default, text: '' };
        if (payload) {
            this.uuid = payload.uuid;
            this.storeTitle = payload.jsonData.storeTitle;
        }
    }
}
